import { Route, Routes, Navigate } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth';
import AllActions from 'src/features/parkingActions/routes/AllActions';
import Customise from 'src/features/parkingActions/routes/Customise';
import useHasPermissions from 'src/hooks/useHasPermissions.ts';

const ActionRoutes = () => {
    const permission = useHasPermissions([PERMISSION.PARKING_QUICK_ACTIONS]);
    return permission ? (
        <Routes>
            <Route path="" element={<AllActions />} />
            <Route path="customise" element={<Customise />} />
            <Route path="*" element={<Navigate to=".." />} />
        </Routes>
    ) : (
        <Navigate to=".." />
    );
};

export default ActionRoutes;
